import { BaseLayout } from './base_layout';
import { StackableLayout } from './stackable_layout';
import { ProportionalStackableLayout } from './proportional_stackable_layout';

export const LayoutFactory = {
    create: config => {
        if (config.layout === 'stack') {
            if (ProportionalStackableLayout.isProportional(config)) {
                return new ProportionalStackableLayout(config)
            }

            return new StackableLayout(config);
        }

        return new BaseLayout(config);
    }
};